/* @zyf2e/monitor-react version ' + 2.1.53 */
import { ERRORTYPES, BREADCRUMBTYPES } from '@zyf2e/monitor-shared';
import { isError, extractErrorStack, Severity } from '@zyf2e/monitor-utils';
import { breadcrumb, transportData } from '@zyf2e/monitor-core';

function errorBoundaryReport(ex) {
    if (!isError(ex)) {
        console.warn('传入的react error不是一个object Error');
        return;
    }
    var error = extractErrorStack(ex, Severity.Normal);
    error.type = ERRORTYPES.REACT_ERROR;
    breadcrumb.push({
        type: BREADCRUMBTYPES.REACT,
        category: breadcrumb.getCategory(BREADCRUMBTYPES.REACT),
        data: error.name + ": " + error.message,
        level: Severity.fromString(error.level)
    });
    transportData.send(error);
}

export { errorBoundaryReport };
/* follow me on Github! @cjinhuo */
//# sourceMappingURL=react.esm.js.map
